import Vue from 'vue';

export const useSession = () => Vue.prototype.$session;
